/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * <p>Holds allowed sort fields on search of reports<\/p>
 **/
export var SortCriteriaField;
(function (SortCriteriaField) {
    SortCriteriaField["LAST_UPDATED_TIME"] = "LAST_UPDATED_TIME";
    SortCriteriaField["REPORT_PATH"] = "REPORT_PATH";
    SortCriteriaField["REPORT_RECORD_LAST_UPDATED_TIME"] = "REPORT_RECORD_LAST_UPDATED_TIME";
    SortCriteriaField["REPORT_RECORD_CREATION_TIME"] = "REPORT_RECORD_CREATION_TIME";
})(SortCriteriaField || (SortCriteriaField = {}));
